'use client';

import { c as _c } from "react/compiler-runtime";
import { useBoolean } from 'usehooks-ts';
import { BaseIssue, IssueTooltipContent } from '../../../shared/issue/base-issue';
import { SearchLinearIssues } from './search-issues';
import { useLinkedLinearIssue } from './use-linked-linear-issue';
import { usePrStore } from '@/lib/stores/pr-store';
export function LinearIssueComponent() {
  const $ = _c(25);
  const {
    owner,
    repo,
    number,
    installationId
  } = usePrStore();
  let t0;
  if ($[0] !== number) {
    t0 = Number.parseInt(number, 10);
    $[0] = number;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== installationId || $[3] !== owner || $[4] !== repo || $[5] !== t0) {
    t1 = {
      owner,
      repo,
      pullNumber: t0,
      installationId
    };
    $[2] = installationId;
    $[3] = owner;
    $[4] = repo;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const linkedIssue = useLinkedLinearIssue(t1);
  const {
    value: open,
    setTrue: openPopover,
    setFalse: closePopover
  } = useBoolean(false);
  if (!linkedIssue) {
    return null;
  }
  const {
    issue,
    isLoading,
    isError,
    setIssue,
    deleteIssue,
    deleteMutation
  } = linkedIssue;
  let t2;
  if ($[7] !== closePopover || $[8] !== openPopover) {
    t2 = v => v ? openPopover() : closePopover();
    $[7] = closePopover;
    $[8] = openPopover;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== closePopover || $[11] !== setIssue) {
    t3 = selectedIssue => {
      setIssue({
        issueId: selectedIssue.identifier,
        issue: selectedIssue
      });
      closePopover();
    };
    $[10] = closePopover;
    $[11] = setIssue;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== linkedIssue.installationId || $[14] !== open || $[15] !== t2 || $[16] !== t3) {
    t4 = <SearchLinearIssues isOpen={open} onOpenChangeAction={t2} onSelectAction={t3} installationId={linkedIssue.installationId} />;
    $[13] = linkedIssue.installationId;
    $[14] = open;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== deleteIssue || $[19] !== deleteMutation.isPending || $[20] !== isError || $[21] !== isLoading || $[22] !== issue || $[23] !== t4) {
    t5 = <BaseIssue providerLabel="Linear" SearchComponent={t4} issue={issue} isError={isError} isLoading={isLoading} onOpenProvider={_temp} onUnlink={deleteIssue} isUnlinking={deleteMutation.isPending} getIssueKey={_temp2} getIssueSummary={_temp3} tooltipContent={_temp4} />;
    $[18] = deleteIssue;
    $[19] = deleteMutation.isPending;
    $[20] = isError;
    $[21] = isLoading;
    $[22] = issue;
    $[23] = t4;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  return t5;
}
function _temp4(issue_3) {
  return <IssueTooltipContent label="Linear" summary={issue_3.title} />;
}
function _temp3(issue_2) {
  return issue_2.title;
}
function _temp2(issue_1) {
  return issue_1.identifier;
}
function _temp(issue_0) {
  window.open(issue_0.url, "_blank", "noopener,noreferrer");
}